import React from 'react';
import PropTypes from 'prop-types';
import { setClassNames } from 'ddc-classnames-js';
import ReviewDate from './ReviewDate';

const ReviewReply = ({
	reply,
	replyDate,
	replyFontSize,
	replyDateFontSize
}) => {
	return (
		<div className="row mt-2">
			<div
				className={`pl-4 col-xs-12 ${setClassNames([
					'dealer-review-content',
					replyFontSize
				])}`}
			>
				<p className="font-weight-bold mb-1">Our Response</p>
				<ReviewDate
					reviewDate={replyDate}
					fontSize={replyDateFontSize}
				/>
				<p className="mt-2">{reply}</p>
				<p>– Business Owner</p>
			</div>
		</div>
	);
};

ReviewReply.propTypes = {
	reply: PropTypes.string.isRequired,
	replyDate: PropTypes.string,
	replyFontSize: PropTypes.string,
	replyDateFontSize: PropTypes.string
};

ReviewReply.defaultProps = {
	replyFontSize: '',
	replyDateFontSize: ''
};

export default ReviewReply;
